import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';

@Injectable({ providedIn: 'root' })
export class SubscriptionService {
    constructor(private http: HttpClient) { }

    /**
     * Check if a user has an active subscription and whether they can purchase a new plan
     * @param userId - The user's ID
     * @returns Observable with subscription status
     */
    checkUserSubscription(userId: string): Observable<any> {
        return this.http.get<any>(`${environment.apiUrl}/subscriptions/check/${userId}`);
    }

    /**
     * Create a new subscription for a user
     * @param subscriptionData - The subscription data
     * @returns Observable with creation result
     */
    createSubscription(subscriptionData: any): Observable<any> {
        return this.http.post<any>(`${environment.apiUrl}/subscriptions/create`, subscriptionData);
    }

    /**
     * Assign the global default plan for Customer user type
     * @param userId - The user's ID
     * @returns Observable with assignment result
     */
    assignDefaultCustomerPlan(userId: string): Observable<any> {
        return this.http.post<any>(`${environment.apiUrl}/subscriptions/assign-default-customer-plan`, { user_id: userId });
    }
}
